import { APP_ENVIRONMENT } from '../../types';
import { AppSettings } from '../../models';
import { ConfigProvider } from './config-provider';
import { Environment, OAuthGrants } from '../../types';
import { Inject, Injectable } from '@angular/core';

@Injectable()
export class ConfigEnvironmentProvider implements ConfigProvider {
  public loadOrder: number;

  constructor(@Inject(APP_ENVIRONMENT) private environment: Environment) {
    this.loadOrder = 1;
  }

  public async getAppSettings(appSettings: AppSettings): Promise<AppSettings> {
    appSettings.onlyWeb = this.environment.onlyWeb;
    appSettings.passwordRules = this.environment.passwordRules ?? {
      minLength: 0,
      minHitPoints: 0,
      hitPointPerRule: 0,
      rules: [],
    };
    appSettings.dashboard = {
      ...appSettings?.dashboard,
      ...this.environment.customizing.ionic?.dashboard,
    };
    appSettings.isOAuthCodeGrantSupported = this.environment.authentication?.grants?.includes('code') ?? false;
    appSettings.supportedOAuthGrants = new Set(
      (this.environment.authentication?.grants as Array<OAuthGrants>) ?? ['password'],
    );
    appSettings.request = {
      ...appSettings.request,
      hasCustomRequestStates: this.environment.request?.hasCustomRequestStates,
      hasCustomRequestType: this.environment.request?.hasCustomRequestType,
    };
    appSettings.customizing = {
      ...appSettings.customizing,
      allowPdfUpload: this.environment.customizing?.allowPdfUpload ?? false,
      allowUserSelfDelete: this.environment.customizing?.allowUserSelfDelete ?? false,
      enableInAppRating: this.environment.customizing?.enableInAppRating ?? false,
      hasUebersicht: this.environment.customizing?.hasUebersicht,
      hasBescheide: this.environment.customizing?.hasBescheide,
      hasUnfinishedAntrage: this.environment.customizing?.hasUnfinishedAntrage ?? false,
      scanbot: this.environment.customizing.ionic?.scanbot,
      health: { timeout: this.environment.customizing.health?.timeout ?? 0 },
      ui: {
        ...appSettings.customizing?.ui,
        app: {
          ...appSettings.customizing?.ui?.app,
          footer: {
            ...appSettings.customizing?.ui?.app?.footer,
            hasCustomBorder: this.environment.customizing.ionic?.footer?.hasCustomBorder ?? false,
            hasCustomBackground: this.environment.customizing.ionic?.footer?.hasCustomBackground ?? false,
          },
        },
      },
    };
    appSettings.pinConfiguration = {
      storage: this.environment.pinConfiguration.storage,
    };

    return Promise.resolve(appSettings);
  }
}
